<template>
    <div>
        <i
            class="icon icon-smile-o positive"
            :class="{'active-mood': mood === 'positive', pointer: editMode}"
            @click="updateValue('positive')"
        ></i>
        <i
            class="icon icon-meh-o neutral"
            :class="{'active-mood': mood === 'neutral', pointer: editMode}"
            @click="updateValue('neutral')"
        ></i>
        <i
            class="icon icon-frown-o negative"
            :class="{'active-mood': mood === 'negative', pointer: editMode}"
            @click="updateValue('negative')"
        ></i>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: false,
            example: 'neutral',
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            mood: null,
        }
    },
    watch: {
        value(val) {
            this.mood = val;
        }
    },
    created() {
        this.mood = this.value;
    },
    methods: {
        updateValue(value) {
            if (!this.editMode) {
                return;
            }

            if (this.mood !== value) {
                this.mood = value;
                this.$emit('input', value);
                this.$emit('changed', value);
                this.$nextTick(() => {
                    this.$emit('post-input', value);
                });
            }
        }
    }
}
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
    div {
        & i {
            @media print {
                display: none;
            }
            font-size: 25px;
            padding: 5px;
            color: #cbcbcb;
            &.pointer {
                cursor: pointer;
            }
            &.active-mood {
                @media print {
                    display: inherit;
                }
                &.neutral {
                    color: #FFC107;
                }
                &.positive {
                    color: #4CAF50;
                }
                &.negative {
                    color: #F44336;
                }
            }
        }
    }
</style>
